var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEuro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 42.5902H21.67C22.83 52.6002 29.44 58.3902 39.87 58.3902C42.02 58.3902 43.89 58.1602 45.59 57.7502V53.2702C43.92 53.6802 41.99 53.8602 39.87 53.8602C32.63 53.8602 27.95 49.7302 26.85 42.6002H40.7V39.4002H26.61V36.1702C26.61 35.7902 26.61 35.4102 26.64 35.0402H40.71V31.8402H27.03C28.37 25.2902 32.96 21.5402 39.87 21.5402C41.99 21.5402 43.92 21.7102 45.59 22.1502V17.6702C43.72 17.2102 41.8 16.9802 39.87 17.0002C29.77 17.0002 23.25 22.4102 21.78 31.8302H18V35.0302H21.48V39.3902H18V42.5902Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEuro);
export default __webpack_public_path__ + "static/media/icon_euro.98a9e7c53948730d63f4e1e53000efd3.svg";
export { ForwardRef as ReactComponent };